export enum PositionStatus {
  Critical = 'CRITICAL',
  Normal = 'NORMAL',
}
